export default "__VITE_ASSET__DF7O2aed__"